import React, { useState, useEffect } from "react";
import { validateToken, callApi } from "../../../lib/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomLoader from "../../GenericComponents/CustomLoader";
import "./CurrentMedications.css"
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import CurrentMedicationsHeader from "./CurrentMedicationsHeader";
import CurrentMedicationsList from "./CurrentMedicationsList";
import "../DrillDownPage.css";


function CurrentMedications() {
  const pages = useSelector((state) => state?.appstate?.pages);
  const [searchList, setSearchList] = useState([]);
  const [CurrentMedicationList, setCurrentMedicationList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const [loading, setLoading] = useState(false);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    let params = {
      patientId: profileData?.profileData?.id,
      // eventType: 9,
      start: startDate,
      timezone: moment.tz.guess(),
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage)
    };
    setLoading(true);
    callApi(`/api/patient/dashboard/medication/list/${params.patientId}`, params, "POST")
      .then((response) => {
        setCurrentMedicationList(response?.data?.data?.patientMedicationList);
        setSearchList(response?.data?.data?.patientMedicationList);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.medicationName.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setCurrentMedicationList(filteredList);
  };


  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />
      <CurrentMedicationsHeader />
      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} />
      <CurrentMedicationsList currentPage={currentPage} perPage={perPage} CurrentMedicationList={CurrentMedicationList} />
    </div>
  );
}

export default CurrentMedications;
